import { Draggable } from 'react-beautiful-dnd';
import { HiOutlineX } from 'react-icons/hi';
import { HiOutlineBars3 } from 'react-icons/hi2';

interface KanbanCardProps {
  id: string;
  index: number;
  content: string;
  description?: string;
  onDelete: (id: string) => void;
  onClick: (card: { id: string; content: string; description: string }) => void;
}

export const KanbanCard = ({ id, index, content, description, onDelete, onClick }: KanbanCardProps) => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`bg-gray-50 p-3 rounded-xl border border-gray-100 group transition-all ${
            snapshot.isDragging ? 'shadow-md' : ''
          } cursor-pointer hover:bg-gray-100`}
          style={{
            ...provided.draggableProps.style,
            left: 'auto !important',
            top: 'auto !important',
          }}
          onClick={() => onClick({ id, content, description: description || '' })}
        >
          <div className="flex justify-between items-start gap-2">
            <div className="flex-1 min-w-0">
              <p className="text-gray-700 text-sm font-medium">{content}</p>
              {description && description.trim() !== '' && (
                <div className="flex items-center gap-1 mt-2">
                  <HiOutlineBars3 className="w-4 h-4 text-gray-400" />
                </div>
              )}
            </div>
            <button
              className="text-gray-400 hover:text-red-500 transition-colors p-1 opacity-0 group-hover:opacity-100 flex-shrink-0"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(id);
              }}
            >
              <HiOutlineX className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </Draggable>
  );
};
